import { jsx as _jsx } from "react/jsx-runtime";
export const omitProps = (Component, omitted) => props => {
  const filteredProps = Object.assign({}, props);
  omitted.forEach(propName => {
    delete filteredProps[propName];
  });
  return /*#__PURE__*/_jsx(Component, Object.assign({}, filteredProps));
};

/**
 * @param props
 * @return The subset of the given props whose names start with `aria-` or `data-`
 */
export const getAriaAndDataProps = props => {
  const propKeyRegex = /^((aria-)|(data-))/;
  return Object.keys(props).reduce((acc, key) => {
    if (!key) return acc;
    if (key.match(propKeyRegex)) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
};